/**
 * Builder for an empty CollectedValues at resolution start.
 * Single source of truth for default flags so Hub + Slack agree.
 */

import type { ResolverEntityKey } from "../relationships";

import type { CollectedValues } from "./types";

interface InitInput {
  actionId: string;
  sourceEntity: ResolverEntityKey;
  sourceId: string;
}

export function buildInitialCollected(input: InitInput): CollectedValues {
  return {
    actionId: input.actionId,
    sourceEntity: input.sourceEntity,
    sourceId: input.sourceId,
    picks: {},
    fields: {},
    persistBackfill: true,
    extras: {},
    confirmed: false,
  };
}
